import { Description } from '@dgx-pr-spa/shared/util';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { fadeInOut } from '@dgx-pr-spa/shared/util';
import { ReplacementOffer, OfferType } from '@dgx-pr-spa/shared/util';
import {
  Component,
  Output,
  EventEmitter,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-product-cards',
  templateUrl: './product-cards.component.html',
  styleUrls: ['./product-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInOut],
})
export class ProductCardsComponent {
  constructor(public viewOffersService: ViewOffersService) {}

  /**
   * Emits the offer clicked for comparison
   */
  @Output()
  comparisonClicked: EventEmitter<ReplacementOffer> = new EventEmitter();

  /**
   * Emits an event back to the parent - used for GA
   */
  @Output() cardClicked: EventEmitter<ReplacementOffer> = new EventEmitter();

  /**
   * Receives an array of offers to be displayed
   */
  @Input() replacementOffers = [] as ReplacementOffer[];

  /**
   * Set the limit on the number of offers that can be compared
   */
  @Input() limit = 2;

  /**
   * Set visible
   */
  @Input() visible = 3;

  /**
   * Record the number of comparisons selected
   */
  @Input() comparisonsSelected = [] as ReplacementOffer[];

  /**
   * Array used to store the selected offers | Emited back | Dynamically updated
   */
  selectedOffers = [] as ReplacementOffer[];

  /**
   * Offer Type values used to determine if enhanced model
   */
  offerType = OfferType;

  Description = Description;

  blockState = [];

  /**
   * RRPFlag value for the current product
   */
  @Input() rrpFlag: boolean;

  blockIndex(i) {
    return Math.floor(i / 4);
  }

  // TODO convert to pipe
  deliveryPrice(replacement: ReplacementOffer) {
    const deliveryService =
      replacement?.services?.filter(
        (service) => service.description === Description.Delivery
      )[0] || null;
    return deliveryService?.price_gross;
  }

  /**
   * Emit event back to parent when offer is clicked for comparison
   */
  onComparisonClick(offer: ReplacementOffer) {
    this.comparisonClicked.emit(offer);
  }

  /**
   * Emit event back to parent when offer card is clicked
   */
  onCardClick(event: ReplacementOffer) {
    this.cardClicked.emit(event);
  }

  /**
   * Getter returns boolean to set the disabled state of the all non selected CTAs
   */
  get limitReached() {
    return !!(this.comparisonsSelected?.length === this.limit);
  }

  disableClick(event) {
    event.stopPropagation();
  }
}
